import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "SjRedesign"
});
const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.53125 15.9616C1.53125 15.8277 1.63976 15.7192 1.77361 15.7192H18.4183C18.5522 15.7192 18.6607 15.8277 18.6607 15.9616V17.0341C18.6607 17.168 18.5522 17.2765 18.4183 17.2765H1.77361C1.63976 17.2765 1.53125 17.168 1.53125 17.0341V15.9616Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.3168 17.2315L9.31514 13.1554L10.8724 13.1548L10.874 17.2308L9.3168 17.2315Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.55371 4.33746C1.55371 3.69244 2.0766 3.16955 2.72163 3.16955L17.4706 2.98706C18.1156 2.98706 18.6385 3.50995 18.6385 4.15498V13.1496C18.6385 13.7946 18.1156 14.3175 17.4706 14.3175L2.72163 14.5C2.07661 14.5 1.55371 13.9771 1.55371 13.3321V4.33746ZM13.5529 4.82672C13.7464 4.82672 13.9033 4.98359 13.9033 5.17709V5.60533V8.71977V9.14801C13.9033 9.34151 13.7464 9.49838 13.5529 9.49838H13.1247H12.6963C12.5029 9.49838 12.346 9.34162 12.3459 9.14818L12.3457 8.71977C12.3457 7.42972 11.2999 6.38394 10.0099 6.38394C9.69868 6.38394 9.40352 6.44438 9.13412 6.55343L8.73717 6.71411C8.5578 6.78672 8.35353 6.70017 8.28093 6.52081L7.95956 5.72691C7.88696 5.54754 7.9735 5.34328 8.15287 5.27067L8.54982 5.10999C9.00172 4.92706 9.49506 4.82672 10.0099 4.82672C10.8865 4.82672 11.6954 5.11643 12.3461 5.60533V5.17709C12.3461 4.98359 12.503 4.82672 12.6965 4.82672H13.5529ZM6.11645 8.71958V11.834V12.2623C6.11645 12.4558 6.27332 12.6126 6.46683 12.6126H7.3233C7.5168 12.6126 7.67367 12.4558 7.67367 12.2623V11.8343C8.32432 12.323 9.13309 12.6126 10.0095 12.6126C10.5243 12.6126 11.0177 12.5123 11.4696 12.3294L11.8665 12.1687C12.0459 12.0961 12.1324 11.8918 12.0598 11.7124L11.7385 10.9185C11.6659 10.7392 11.4616 10.6526 11.2822 10.7252L10.8853 10.8859C10.6159 10.995 10.3207 11.0554 10.0095 11.0554C8.71945 11.0554 7.67367 10.0096 7.67367 8.71958V8.29135C7.67367 8.09784 7.5168 7.94097 7.3233 7.94097H6.46683C6.27332 7.94097 6.11645 8.09784 6.11645 8.29135V8.71958Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_5);
}
var SJ_Redesign = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { SJ_Redesign as default };
